import { Injectable } from '@angular/core';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { PoTokenAuthService } from 'src/app/shared/services/po-token-auth.service';
import { RfqTokenAuthService } from 'src/app/shared/services/rfq-token-auth.service';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {

  constructor(
    private webApiService: WebApiService,
    private poTokenAuth: PoTokenAuthService,
    private rfqTokenAuth: RfqTokenAuthService
  ) { }

  async fetchRfqDetails(params: any): Promise<any> {
    let apiUrl = `/quote/fetchRfqDetails`;
    return this.webApiService.postRequest<any>(apiUrl,params);
  }
  async fetchRfqDetailsByPoToken(params: any): Promise<any> {
    const apiUrl = `/quote/fetchRfqDetailsByPoToken`;
    const poId = this.poTokenAuth.getPoId();
    const requestBody = {
      ...params,
      ...(poId && !params?.purchaseOrderId ? { purchaseOrderId: poId } : {})
    };
    const options = this.poTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
  }

  async fetchRfqDetailsByRfqToken(params: any): Promise<any> {
    const apiUrl = `/quote/fetchRfqDetailsByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
  }
  async fetchRfqLineItemAttachments(params: any): Promise<any> {
    let apiUrl = `/quote/fetchRfqLineItemAttachments`;
    return this.webApiService.postRequest<any>(apiUrl,params);
  }

  async fetchRfqLineItemDetails(params: any): Promise<any> {
    let apiUrl = `/quote/fetchRfqLineItemDetails`;
    return this.webApiService.postRequest<any>(apiUrl,params);
  }

  async fetchRfqLineItemDetailsByRfqToken(params: any): Promise<any> {
    const apiUrl = `/quote/fetchRfqLineItemDetailsByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, params, options);
  }

  async fetchRfqLineItemAttachmentsByRfqToken(params: any): Promise<any> {
    const apiUrl = `/quote/fetchRfqLineItemAttachmentsByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, params, options);
  }

  fetchAllIncoterms(): Promise<any> {
    let apiUrl = `/quote/fetchAllIncoterms`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  fetchAllIncotermsByRfqToken(): Promise<any> {
    let apiUrl = `/quote/fetchAllIncotermsByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }

  fetchAllOfferedQuality(): Promise<any> {
    let apiUrl = `/quote/fetchAllOfferedQuality`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  fetchAllOfferedQualityByRfqToken(): Promise<any> {
    let apiUrl = `/quote/fetchAllOfferedQualityByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }

  fetchAllQuteAttachmentType(type: any): Promise<any> {
    let apiUrl = `/quote/fetchAllQuteAttachmentType/${type}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  fetchAllQuteAttachmentTypeByRfqToken(type: any): Promise<any> {
    let apiUrl = `/quote/fetchAllQuteAttachmentTypeByRfqToken/${type}`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }
  
  fetchAllDeclineReason(): Promise<any> {
    let apiUrl = `/quote/fetchAllDeclineReason`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  fetchAllDeclineReasonByRfqToken(): Promise<any> {
    let apiUrl = `/quote/fetchAllDeclineReasonByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }

  getQuoteDraftData(tab:string,supplierId:number):Promise<any>{
    let apiUrl = `/quote/getQuoteDraftData/${tab}/${supplierId}`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  getQuoteDraftDataByRfqToken(tab:string, quoteId:number):Promise<any>{
    let apiUrl = `/quote/getQuoteDraftDataByRfqToken/${tab}/${quoteId}`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }
  

  saveQuoteAsDraft(params: any): Promise<any> {
    let apiUrl = `/quote/saveAsdraft`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  updateQuoteAsDraft(params: any): Promise<any> {
    let apiUrl = `/quote/updateQuoteDraft`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  getlastQuoteId():Promise<any>{
    let apiUrl = `/quote/getlastQuoteId`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  getlastQuoteIdByRfqToken():Promise<any>{
    let apiUrl = `/quote/getlastQuoteIdByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }

  getQuoteId(params: any): Promise<any> {
    let apiUrl = `/quote/getQuoteId`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  getQuoteIdByRfqToken(params: any): Promise<any> {
    const apiUrl = `/quote/getQuoteIdByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const supplierId = this.rfqTokenAuth.getSupplierId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {}),
      ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
  }

  saveQuoteAsDraftByRfqToken(params: any): Promise<any> {
    const apiUrl = `/quote/saveAsdraftByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const supplierId = this.rfqTokenAuth.getSupplierId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {}),
      ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
  }

  updateQuoteAsDraftByRfqToken(params: any): Promise<any> {
    const apiUrl = `/quote/updateQuoteDraftByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const supplierId = this.rfqTokenAuth.getSupplierId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {}),
      ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
  }

  deleteAttachment(attachmentArr: number[]):Promise<any>{
    const attachments = { attachmentArr };
    let apiUrl = `/quote/deleteAttachment`;
    return this.webApiService.postRequest<any>(apiUrl,attachments )
  }

  deleteAttachmentByRfqToken(attachmentArr: number[]):Promise<any>{
    const attachments = { attachmentArr };
    const apiUrl = `/quote/deleteAttachmentByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, attachments, options);
  }

 declineRfq(params:any): Promise<any> {
  let apiUrl = `/quote/declineRfq`;
  return this.webApiService.postRequest<any>(apiUrl, params
  );
}

 declineRfqByRfqToken(params:any): Promise<any> {
  const apiUrl = `/quote/declineRfqByRfqToken`;
  const options = this.rfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}


async fetchRfqPreviewDetails(params: any): Promise<any> {
  let apiUrl = `/quote/fetchRfqPreviewDetailsByRfqIdAndBuyerId`;
  return this.webApiService.postRequest<any>(apiUrl,params);
}

async fetchRfqPreviewDetailsByRfqToken(params: any): Promise<any> {
  let apiUrl = `/quote/fetchRfqPreviewDetailsByRfqToken`;
  const options = this.rfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}

async fetchQuotePreviewDetails(params: any): Promise<any> {
  let apiUrl = `/quote/fetchQuotePreviewDetailsByQuoteIdAndSupplierId`;
  return this.webApiService.postRequest<any>(apiUrl,params);
}

async fetchQuotePreviewDetailsByRfqToken(params: any): Promise<any> {
  let apiUrl = `/quote/fetchQuotePreviewDetailsByRfqToken`;
  const options = this.rfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}

async sendQuotationAcknowledgment(params:any):Promise<any>{
    let apiUrl = `/quote/sendQuotationAcknowledgment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

async sendQuotationAcknowledgmentByRfqToken(params:any):Promise<any>{
    const apiUrl = `/quote/sendQuotationAcknowledgmentByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const supplierId = this.rfqTokenAuth.getSupplierId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {}),
      ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, requestBody, options)
  }

async sendDeclineRfqAcknowledgment(params:any):Promise<any>{
    let apiUrl = `/quote/sendDeclineRfqAcknowledgment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

async sendDeclineRfqAcknowledgmentByRfqToken(params:any):Promise<any>{
    const apiUrl = `/quote/sendDeclineRfqAcknowledgmentByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const supplierId = this.rfqTokenAuth.getSupplierId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {}),
      ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl,requestBody,options)
  }


async sendAcknowledgeRfqAcknowledgment(params:any):Promise<any>{
    let apiUrl = `/quote/sendAcknowledgeRfqAcknowledgment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

async sendAcknowledgeRfqAcknowledgmentByRfqToken(params:any):Promise<any>{
    const apiUrl = `/quote/sendAcknowledgeRfqAcknowledgmentByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const supplierId = this.rfqTokenAuth.getSupplierId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {}),
      ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl,requestBody,options)
  }
async fetchServiceRfqDetails(params: any): Promise<any> {
  let apiUrl = `/services/rfq/fetchServiceRfqDetailPageData`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

async fetchServiceRfqLineItemAttachments(params: any): Promise<any> {
  let apiUrl = `/services/rfq/fetchServiceRfqLineItemAttachments`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

async acknowledgeServiceRfq(params: any): Promise<any> {
  let apiUrl = `/services/rfq/acknowledgeServiceRfq`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

async declineServiceRfq(params: any): Promise<any> {
  let apiUrl = `/services/rfq/declineServiceRfq`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

getServiceQuoteId(params: any): Promise<any> {
  let apiUrl = `/services/rfq/getServiceQuoteId`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

getLastServiceQuoteId(): Promise<any> {
  let apiUrl = `/services/rfq/getLastServiceQuoteId`;
  return this.webApiService.getRequest<any>(apiUrl);
}

saveServiceQuoteAsDraft(params: any): Promise<any> {
  let apiUrl = `/services/rfq/saveServiceQuoteAsDraft`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

updateServiceQuoteDraft(params: any): Promise<any> {
  let apiUrl = `/services/rfq/updateServiceQuoteDraft`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

getServiceQuoteDraftData(tab: string, quoteId: number): Promise<any> {
  let apiUrl = `/services/rfq/getServiceQuoteDraftData/${tab}/${quoteId}`;
  return this.webApiService.getRequest<any>(apiUrl);
}

fetchServiceRfqLineItemsForQuote(params: any): Promise<any> {
  let apiUrl = `/services/rfq/fetchServiceRfqLineItemsForQuote`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

async fetchQuoteListByRfqId(params: any): Promise<any> {
  let apiUrl = `/quote/fetchQuoteListByRfqId`;
  return this.webApiService.postRequest<any>(apiUrl,params);
}

async quoteOperationsByBUyer(params: any): Promise<any> {
  let apiUrl = `/quote/quoteOperationsByBUyer`;
  return this.webApiService.postRequest<any>(apiUrl,params);
}

async importQuoteByExcel(params: any): Promise<any> {
  let apiUrl = `/quote/importQuoteByExcel`;
  return this.webApiService.postRequest<any>(apiUrl,params);
}

fetchAllCurrency(): Promise<any> {
  let apiUrl = `/quote/fetchAllCurrency`;
  return this.webApiService.getRequest<any>(apiUrl);
}






  




}
